import { FC, useCallback, useState } from 'react';

import toggleIcon from 'shared/components/SuperhostPage/assets/accordion-toggle.svg';

import { EMPLOYEES_URL, QUALITY_OF_SERVICE_URL } from 'shared/containers/Superhost/const';

import style from './Faq.css';
import { Link } from '@cian/ui-kit';

const FAQ_ITEMS = [
  {
    question: 'Как присоединиться к программе лояльности?',
    answer: (
      <>
        Вы автоматически станете участником программы лояльности «Суперхозяин» после публикации хотя бы одного
        объявления посуточной аренды с онлайн-бронированием. Мы присвоим вам уровень на основании текущих показателей
        качества сервиса.
      </>
    ),
  },
  {
    question: 'Как проверить свой статус?',
    answer: (
      <>
        Во вкладке «Качество сервиса» в вашем личном кабинете{' '}
        <Link href={QUALITY_OF_SERVICE_URL}>{QUALITY_OF_SERVICE_URL}</Link>
      </>
    ),
  },
  {
    question: 'Как будет рассчитываться статус Суперхозяина для агентств?',
    answer: (
      <>
        На уровень влияют те же параметры, но помимо показателей главного аккаунта также учитываются уровни всех
        подключённых сотрудников — они рассчитываются индивидуально и их можно проверить по{' '}
        <Link href={EMPLOYEES_URL}>ссылке</Link>
      </>
    ),
  },
  {
    question: 'Когда я получу свою наклейку?',
    answer: (
      <>
        Мы отправляем наклейки один раз в месяц простым письмом Почты России — ожидайте доставку в почтовый ящик по
        указанному в заявке адресу
      </>
    ),
  },
];

export const Faq: FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = useCallback((index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  }, []);

  return (
    <section className={style['section']}>
      <div className={style['inner']}>
        <h2 className={style['title']}>Ответы на вопросы ниже</h2>
        <div className={style['list']}>
          {FAQ_ITEMS.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div key={item.question} className={style['item']}>
                <div className={style['question']} onClick={() => handleToggle(index)}>
                  <p className={style['question-text']}>{item.question}</p>
                  <img alt="" className={isOpen ? style['toggle--open'] : style['toggle']} src={toggleIcon} />
                </div>
                {isOpen && <p className={style['answer']}>{item.answer}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
